import { makeEndpointFns } from '../fns';
import { GetAllConfigsRequest, GetAllConfigsResponse, SetConfigDto } from '@whiz-cart/node-shared/models/config/systemConfig';
import { SystemConfigEntry } from '@whiz-cart/node-shared/models/config/systemConfig';

const { POST, PUT } = makeEndpointFns('storeManager');

export const storeSettings = {
    /** Endpoints relating to system config. These are separate from the normal config endpoints due to claims. */
    config: {
        /** Get multiple matching config entries at once */
        getConfigValues: POST('api/v1/storeSettings/configValues', GetAllConfigsResponse, {
            body: GetAllConfigsRequest,
        }),
        /** Set multiple config entries at once */
        setConfigValues: PUT('api/v1/storeSettings/configValues', SystemConfigEntry.array(), {
            body: SetConfigDto.array(),
        }),
    },
};
